import AdminPanelSettings from "@mui/icons-material/AdminPanelSettings";
import ToggleOn from "@mui/icons-material/ToggleOn";
import { ResourceProps } from "@refinedev/core";

// "Admin" group shown above the seller menu for users with an admin role (see
// App). Kept separate from navigationItems so the seller menu is untouched.
// New admin pages are added as children of the "admin" group.
export const getAdminResources = (): ResourceProps[] => [
  {
    name: "admin",
    meta: {
      icon: <AdminPanelSettings />,
    },
  },
  {
    name: "feature-flags",
    list: "/admin/feature-flags",
    show: "/admin/feature-flags/:key",
    meta: {
      parent: "admin",
      icon: <ToggleOn />,
    },
  },
];
